export const ANALYTICS = '/analytics';
export const COMPANY_INSTRUCTIONS = '/companyInstructions';
export const CUSTOM_CARDS = '/customCards';
export const USER_LOGS = '/userLogs';
export const HOME = '/';
export const LOGOUT = '/logout';